import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import './responsive.css';
import App from "./App";
import { BrowserRouter } from 'react-router-dom';
import { Provider as ReduxProvider } from "react-redux";
import store from './store/store';
import { Authenticator } from "@aws-amplify/ui-react";
import { Amplify } from "aws-amplify";
import awsConfig from "./aws-exports";

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === '[::1]' ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Assuming you have two redirect URIs, and the first is for localhost and second is for production
const [
  localRedirectSignIn,
] = awsConfig.oauth.redirectSignIn.split(',');

const [
  localRedirectSignOut,
] = awsConfig.oauth.redirectSignOut.split(',');

const updatedAwsConfig = {
  ...awsConfig,
  oauth: {
    ...awsConfig.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn : `${window.location.origin}/`,
    redirectSignOut: isLocalhost ? localRedirectSignOut : `${window.location.origin}/`,
  }
}
Amplify.configure(updatedAwsConfig);

Amplify.DataStore.configure({
  maxRecordsToSync: 10000,
  fullSyncInterval: 1
})
Amplify.DataStore.start();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Authenticator.Provider>
      <BrowserRouter>
          <ReduxProvider store={store}>
            <App />
          </ReduxProvider>
      </BrowserRouter>
  </Authenticator.Provider>
);
